<template>
  <CBox
    d="flex"
    flexDirection="column"
  >
    <OmtRow mb="24px">
      <CFlex direction="column">
        <OmtTypography
          as="h1-bold"
          color="var(--colors-light-primary-navy-blue)"
        >
          Credenciados
        </OmtTypography>
      </CFlex>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography
        as="h2-bold"
        color="#4A5E77"
      >
        {{ getEstablishmentDescription }}
      </OmtTypography>
    </OmtRow>
    <!-- Oculto temporariamente -->
    <OmtRow>
      <CBox
        w="100%"
        display="flex"
        alignItems="center"
        mb="24px"
        pb="4px"
        pt="2"
        grid-column-gap="8px"
      >
        <CBox
          position="relative"
          flex-shrink="0"
        >
          <OmtButton
            size="sm"
            :variant="hasFilters ? 'solid' : 'outline'"
            rightIcon="sliders-h"
            iconMarginRight="0"
            borderRadius="0px"
            :iconColor="hasFilters ? 'white' : '#4A5E77'"
            iconSize="sm"
            border=".5px solid var(--colors-light-secondary-divider)"
            w="auto !important"
            px="16px"
            :bg="hasFilters ? 'var(--colors-light-primary-navy-blue)' : 'white'"
            @click="showFilterModal = true"
          >
            <OmtTypography
              as="button-small"
              :color="hasFilters ? 'white' : '#4A5E77'"
            >
              Filtrar
            </OmtTypography>
          </OmtButton>
          <CBox
            v-show="filtersCount"
            position="absolute"
            top="-8px"
            right="0"
            bg="white"
            border="1px solid var(--colors-light-primary-navy-blue)"
            border-radius="12px"
            min-h="16px"
            min-w="16px"
            h="16px"
            w="16px"
            display="flex"
            justify-content="center"
            align-items="center"
            z-index="1"
          >
            <OmtTypography
              as="p2"
              color="var(--colors-light-primary-navy-blue)"
              font-weight="bold"
            >
              {{ filtersCount }}
            </OmtTypography>
          </CBox>
        </CBox>
        <OmtButton
          variant="ghost"
          :disabled="!filtersCount && !sort"
          size="sm"
          w="105px !important"
          ml="auto"
          @click="cleanSortsAndFilters"
        >
          Limpar
        </OmtButton>
      </CBox>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography
        as="h2-bold"
        color="#4A5E77"
      >
        Localize por nome
      </OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtInput
        v-model="textSearch"
        variant="filled"
        placeholder="Digite o nome do profissional ou clínica"
        icon-right="search"
      />
    </OmtRow>
    <OmtRow
      v-for="(item, index) in list"
      :key="index"
    >
      <DoctorsListItem
        :TipoLogradouro="item.TipoLogradouro"
        :EnderecoRua="item.EnderecoRua"
        :EnderecoNumero="item.EnderecoNumero"
        :EnderecoComplemento="item.EnderecoComplemento"
        :EnderecoBairro="item.EnderecoBairro"
        :CodigoEstado="item.CodigoEstado"
        :EnderecoCidade="item.EnderecoCidade"
        :DescricaoPrestador="item.DescricaoPrestador"
        :DescricaoEspecialidade="item.DescricaoEspecialidade"
        :Distancia="item.Distancia"
        :Network="item.NetworkName"
        :Favorito="item.Favorito"
        :CodigoPrestador="item.CodigoPrestador"
        :SrEndereco="item.SrEndereco"
        :DsIdioma="item.DsIdioma"
        :Nota="item.ScoreTotal"
        :WhatsApp="item.WhatsApp"
        :Teleconsulta="item.Teleconsulta"
        :Agendamento="item.Agendamento"
        :colorSecondary="true"
        @click="onClick(item)"
      />
    </OmtRow>

    <OmtRow v-if="list.length === 0">
      <OmtTypography
        as="p1"
        color="#4A5E77"
        >Nenhum resultado encontrado</OmtTypography
      >
    </OmtRow>

    <FilterModal
      v-if="showFilterModal"
      :filters="filters"
      :facilities="facilities"
      :languages="languages"
      :networks="networks"
      :subspecialties="subspecialties"
      @close="showFilterModal = false"
      @save="onFilterSave"
    />
  </CBox>
</template>

<script>
import DoctorsListItem from "@/components/Organisms/AffiliateSearch/DoctorsListItem.vue";
import FilterModal from "@/components/Organisms/AffiliateSearch/FilterModal.vue";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import _ from "lodash";
import {
  countActiveFilters,
  filterAffiliateList,
  getFacilities,
  getLanguages,
  getNetworkList,
  getSubspecialtyList,
  sortAffiliateList,
  withNetworkName
} from "@/utils/accreditedListFilters";

export default {
  name: "AccreditedList",
  components: { DoctorsListItem, FilterModal },
  data() {
    return {
      textSearch: "",
      originalList: [],
      list: [],
      showFilterModal: false,
      facilities: [],
      languages: [],
      networks: [],
      subspecialties: []
    };
  },
  computed: {
    ...mapState("openNetworkSearch", ["selectedFilters", "selectedSort"]),
    ...mapGetters("openNetworkSearch", ["getPrestadores", "getEstablishmentDescription"]),
    filters() {
      return this.selectedFilters;
    },
    sort() {
      return this.selectedSort;
    },
    hasFilters() {
      return this.filtersCount > 0;
    },
    filtersCount() {
      return countActiveFilters(this.filters);
    },
    hasSubspecialties() {
      return Array.isArray(this.subspecialties) && this.subspecialties.length > 0;
    }
  },
  watch: {
    textSearch: {
      handler: _.debounce(function () {
        this.filterList();
      }, 500)
    }
  },
  methods: {
    ...mapActions("openNetworkSearch", ["buscarPorRegiaoAnonimo", "setSelectedProvider"]),
    ...mapMutations("openNetworkSearch", ["SET_FILTERS", "SET_SORT", "SET_DOCTOR_DETAIL"]),
    async loadPrestadores() {
      try {
        this.$root.$emit("show-loading");
        const prestadores = await this.buscarPorRegiaoAnonimo();

        if (prestadores && prestadores.length > 0) {
          this.originalList = prestadores.map(withNetworkName);
          this.setFilterOptions();
          this.filterList();
          this.onSortSave("");
        }
      } catch (error) {
        console.error("Erro ao carregar prestadores:", error);
      } finally {
        this.$root.$emit("hide-loading");
      }
    },
    filterList() {
      this.list = filterAffiliateList(this.originalList, this.filters, this.textSearch);
    },
    onClick(item) {
      this.setSelectedProvider(item);
      this.$router.push({ name: "network.doctor.detail", params: { CodigoPrestador: item.CodigoPrestador } });
    },
    onFilterSave(filters) {
      this.SET_FILTERS(filters);
      this.filterList();
    },
    onSortSave(sort) {
      this.SET_SORT(sort);
      this.list = sortAffiliateList(this.list, sort);
    },
    cleanSortsAndFilters() {
      this.onFilterSave({});
      this.onSortSave("");
      this.filterList();
    },
    setFilterOptions() {
      this.facilities = getFacilities(this.originalList);
      this.languages = getLanguages(this.originalList);
      this.networks = getNetworkList(this.originalList);
      this.subspecialties = getSubspecialtyList(this.originalList);
    }
  },
  async mounted() {
    await this.loadPrestadores();
  }
};
</script>
